// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.water_type_enum_01133f4d */
var WaterTypeEnum01133f4d;
(function (WaterTypeEnum01133f4d) {
    WaterTypeEnum01133f4d["Amsterdam tap water"] = "Amsterdam tap water";
    WaterTypeEnum01133f4d["Demiwater"] = "Demiwater";
})(WaterTypeEnum01133f4d || (WaterTypeEnum01133f4d = {}));
;
export default WaterTypeEnum01133f4d;
/** Zod schema for water_type_enum_01133f4d */
export const waterTypeEnum01133f4d = z.nativeEnum(WaterTypeEnum01133f4d);
//# sourceMappingURL=WaterTypeEnum01133f4d.js.map